module.exports = __webpack_public_path__ + "static/media/Purse.79219246.svg";